export const APPROVED = 'Approved'
export const VOIDED = 'Voided'
export const AUTHORIZED = 'Authorized'
export const COMPLETED = 'Completed'
